import { NavLink } from 'react-router-dom'
import { Board } from './Board.type'
import React, { Fragment, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { useStores } from '../../hooks/useStore'
import BoardTd from './BoardTd'
import Loading from '../loading/Loading'

interface Props {
  limit?: number
}
export const BoardNavigation: React.FC<Props> = observer(({ limit }) => {
  const { boardStore } = useStores()
  const [boardList, setBoardList] = useState([] as Board[][])

  useEffect(() => {
    const loadBoard = async () => {
      await boardStore.load()
      setBoardList(boardStore.getPartition(limit ?? 6))
    }

    loadBoard()
  }, [boardStore, limit])

  const getElement = () => {
    return boardList.length > 0 ? (
      boardList.map((part) => {
        return (
          <ul className="noti">
            {part.map((b) => (
              <Fragment>
                <li key={`board_key_${b.id}`}>
                  <NavLink to={`/BoardView/${b.id}`}>- [ {b.tit} ]</NavLink>
                </li>
              </Fragment>
            ))}
          </ul>
        )
      })
    ) : (
      <Loading />
    )
  }
  return <React.Fragment>{getElement()}</React.Fragment>
})

interface BoardListProps {}

export const BoardList: React.FC<BoardListProps> = observer(() => {
  const { boardStore } = useStores()

  const getBoardList = () => {
    if (boardStore.boards.length < 1) {
      return <Loading />
    }
    return boardStore.boards.map((board) => {
      let createTime = ''
      if (board.createTime != null) {
        const d = new Date(board.createTime)
        if (!isNaN(d.getTime())) {
          createTime = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d
            .getDate()
            .toString()
            .padStart(2, '0')}`
        }
      }
      return (
        <BoardTd
          titleTxt={[
            { text: board.type, width: 10, tag: 'black' },
            { text: board.tit, width: 70 },
            { text: createTime, width: 20 },
          ]}
          pageNumber={board.id}
        />
      )
    })
  }
  useEffect(() => {
    boardStore.load()
  }, [boardStore])
  return <React.Fragment>{getBoardList()}</React.Fragment>
})
